import { gsap } from 'gsap';

const mobileMenu = {
    tl: null,
    timeout: false,
    delay: 250,
    progress: 0,

    init: function () {
        let self = this;
        self.initMenu();
    },

    initMenu: function () {
        let self = this;
        let burger = document.querySelector('.js-burger');
        let cross = document.querySelector('.js-close');
        let menu = document.querySelector('.c-navbar-mobile__content');

        let body = document.querySelector('body');
        if (body.classList.contains('body-fixed')) {
            body.classList.remove('body-fixed');
        }

        burger.addEventListener('click', function (event) {
            event.preventDefault();
            self.timeline();

            if (menu.classList.contains('c-navbar-mobile__content--hidden'))
            {
                menu.classList.remove('c-navbar-mobile__content--hidden');
                self.tl.play();

            }
            else
            {
                menu.classList.add('c-navbar-mobile__content--hidden');
            }

            if (burger.classList.contains('c-navbar-mobile__opened')) {

                burger.classList.remove('c-navbar-mobile__opened');
                burger.classList.add('c-navbar-mobile__closed');
                cross.classList.add('c-navbar-mobile__opened');
                cross.classList.remove('c-navbar-mobile__closed');
                document.querySelector('body').classList.add('body-fixed');
            }

        });

        cross.addEventListener('click', function (event) {
            event.preventDefault();

            if (!menu.classList.contains('c-navbar-mobile__content--hidden')) {
                self.tl.reverse();
            }

            if (cross.classList.contains('c-navbar-mobile__opened')) {
                cross.classList.remove('c-navbar-mobile__opened');
                cross.classList.add('c-navbar-mobile__closed');
                burger.classList.add('c-navbar-mobile__opened');
                burger.classList.remove('c-navbar-mobile__closed');
                document.querySelector('body').classList.remove('body-fixed');
            }

        });

        if (menu) {
            let links = Array.prototype.slice.call(document.querySelectorAll('.c-navbar-mobile .c-navbar__nav-item'));
            let dropDownLinks = Array.prototype.slice.call(document.querySelectorAll('.c-navbar-mobile .c-dropdown-menu__content-item'));
            links.forEach(function (link) {
                link.addEventListener('click', function () {
                    if (!menu.classList.contains('c-navbar-mobile__content--hidden')) {
                        self.tl.reverse();
                    }

                    if (cross.classList.contains('c-navbar-mobile__opened')) {
                        cross.classList.remove('c-navbar-mobile__opened');
                        cross.classList.add('c-navbar-mobile__closed');
                        burger.classList.add('c-navbar-mobile__opened');
                        burger.classList.remove('c-navbar-mobile__closed');
                        document.querySelector('body').classList.remove('body-fixed');
                    }
                });
            });

            dropDownLinks.forEach(function (dropDownLink) {
                dropDownLink.addEventListener('click', function () {
                    if (!menu.classList.contains('c-navbar-mobile__content--hidden')) {
                        self.tl.reverse();
                    }

                    if (cross.classList.contains('c-navbar-mobile__opened')) {
                        cross.classList.remove('c-navbar-mobile__opened');
                        cross.classList.add('c-navbar-mobile__closed');
                        burger.classList.add('c-navbar-mobile__opened');
                        burger.classList.remove('c-navbar-mobile__closed');
                        document.querySelector('body').classList.remove('body-fixed');
                    }
                });
            });
        }
    },

    timeline: function () {
        let reverseComplete = false;
        let menuHeight = "100%";
        let menuWidth = "100%";
        let self = this;
        let menu = document.querySelector('.c-navbar-mobile__content');


        if (window.innerWidth <= 992) {
            menuHeight = window.innerHeight;
        }

        if (window.innerWidth > 575) {
            menuWidth = "40%";
        }



        self.tl = gsap.timeline({paused: true, reversed: true, onReverseComplete: function () {
                reverseComplete = true;
                if((reverseComplete) && (!menu.classList.contains('c-navbar-mobile__content--hidden'))) {
                    menu.classList.add('c-navbar-mobile__content--hidden');
                    self.progress = 0;
                    self.tl.kill();
                }
            }});



        self.tl.fromTo(document.querySelector('.c-navbar-mobile__content'), 0.3, {height: 0, width: 0, right: '0', delay: .05, ease: 'Power2.inOut', borderBottomLeftRadius: '100%'}, {height: menuHeight, width: menuWidth, borderBottomLeftRadius: 0})
            .fromTo(document.querySelector('.c-navbar-mobile__content-col'), .3, {opacity: 0, ease: 'Power2.in'}, {opacity: 1, ease: 'Power2.out'});

        self.tl.progress(self.progress);
    },

    getDimension: function () {
        let self = this;
        self.progress = this.tl.progress();
        self.tl.kill();
        self.timeline();
    }
};

let navbarMobile = document.querySelector('.c-navbar-mobile');

if (navbarMobile) {
    mobileMenu.timeline();
    mobileMenu.getDimension();
    mobileMenu.init();
}




window.addEventListener('resize', function() {
    // clear the timeout
    clearTimeout(mobileMenu.timeout);
    // start timing for event "completion"
    mobileMenu.timeout = setTimeout(mobileMenu.getDimension(), mobileMenu.delay);
});


document.addEventListener('LokiRequestEnd', function () {
    if (navbarMobile) {
        mobileMenu.timeline();
        mobileMenu.getDimension();
        mobileMenu.init();
    }
});